import { createReducer } from 'store/helpers';
import {
  SET_ERROR,
  CLEAR_ERROR,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  LOGGED_OUT,
  SET_LOGGED_USER,
  SET_IS_LOGGED_IN,
} from 'store/actions/auth';
import * as tokenServices from 'services/token';
import { addIdPrefix } from 'services/common';

const initialState = {
  error: '',
  isFetching: false,
  userToken: '',
  sentRequestAccessEmailId: '',
  user: tokenServices.getUser() ? JSON.parse(tokenServices.getUser()) : {},
  isLoggedIn: false,
};

const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const setLoggedOut = state =>
  state.merge({
    hasPassed2FA: false,
    hasPassedPasswordAuth: false,
  });

const setLoggedUser = (state, { user }) => state.merge({ user });

const setIsLoggedIn = (state, { isLoggedIn }) => state.merge({ isLoggedIn });

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [LOGGED_OUT]: setLoggedOut,
  [SET_LOGGED_USER]: setLoggedUser,
  [SET_IS_LOGGED_IN]: setIsLoggedIn,
};

export default createReducer(initialState, handlers);
